import { Row, Col, Container } from "react-bootstrap";
import OwnerShopProfile from "../../components/OwnerShopProfile/OwnerShopProfile";
import ShopItemsOwner from "../../components/ShopItemsOwner/ShopItems";
import { useParams } from "react-router-dom";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { useState, useEffect } from "react";
import BackArrow from "../../components/backArrow";
import ShopManagebuttons from "../../components/Shops_manage_buttons";
import { useSelector } from "react-redux";
import { useGetUserShopsByBusinessTypeQuery, useGetShopByIdQuery, useLazyGetShopSuggestionsByVendorIdQuery } from "../../features/shop/shopApiSlice";
import { extractIdFromSlug } from "../../utils/slugUtils";

const MineralAndMining = () => {
  const { id: rawId } = useParams();
  const id = extractIdFromSlug(rawId);
  const [shopData, setShopData] = useState();
  const [suggestdata, setSuggestdata] = useState();
  const [suggest, setSuggest] = useState(0);
  const { name } = useSelector((state) => state.user);

  const { data: userShopsRes } = useGetUserShopsByBusinessTypeQuery({
    userid: name?._id,
    businessType: "gemShop",
  }, { skip: !name?._id });

  const [suggestdetail, setSuggestdetail] = useState(0);

  const { data: shopRes, isLoading: isShopLoading } = useGetShopByIdQuery(id, { skip: !id });

  useEffect(() => {
    if (shopRes?.success) {
      setShopData(shopRes?.data?.Shop);
    }
  }, [shopRes]);

  // Prefer THIS shop's category for post-add dropdowns (Shops[0] was often wrong / empty)
  useEffect(() => {
    const fromThisShop =
      shopRes?.data?.Shop?.shopCategory?.name ||
      shopRes?.data?.Shop?.shopCategory ||
      "";
    const fromFirstGem =
      userShopsRes?.data?.Shops?.[0]?.shopCategory?.name || "";
    const resolved =
      (typeof fromThisShop === "string" && fromThisShop.trim()) ||
      (typeof fromFirstGem === "string" && fromFirstGem.trim()) ||
      "Main catagory Gems&jewelry";
    localStorage.setItem("mycategory", resolved);
  }, [shopRes, userShopsRes]);

  const [getSuggestions] = useLazyGetShopSuggestionsByVendorIdQuery();

  const suggestdatta = () => {
    if (shopData?._id) {
      getSuggestions(shopData._id)
        .unwrap()
        .then((res) => {
          setSuggestdata(res?.data[0]?.suggestions);
        })
        .catch((err) => console.log(err));
    }
  };
  return (
    <Container>
      <Col md={12} lg={11} className="mx-auto">
        <Row>
          <Col md={4} lg={3} className="p-0">
            <OwnerShopProfile
              Name="Update Gems & Jewellery Shop"
              navigateTo="/minerals-mining-update"
              // post="/minerals-Minning-PostAdd"
              myid={id}
              shopid={id}
              shopData={shopData}
              setSuggest={setSuggest}
              suggestdatta={suggestdatta}
              salespromotion="sales promotion"
              icon={<LocalOfferIcon className="silver-icon" />}
            />
          </Col>
          <Col md={8} lg={9} className=" screenHeight custom_ps-4">
            <div className="Form-Shadow h-100">
              <Row>
                <Col lg="4">
                  <BackArrow
                    back={`/rawmaterial-mineralsandmining/${id}`}
                    mystyle="pt-1 ps-2 d-none d-lg-block"
                  />
                </Col>
                <Col lg="8" className="mt-2 pe-4">
                  <ShopManagebuttons
                    businessurl="/minerals-mining-shops"
                    shopid={id}
                  />
                </Col>
              </Row>
              <ShopItemsOwner
                shopData={shopData}
                urlPass="/gems-minerals-item-owner-view"
                suggestdata={suggestdata}
                navigateto="/mineral-mining-form"
                shopid={id}
                post={`/minerals-Minning-PostAdd/${id}`}
                suggest={suggest}
                setSuggest={setSuggest}
                suggestdetail={suggestdetail}
                setSuggestdetail={setSuggestdetail}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </Container>
  );
};

export default MineralAndMining;
